// images
import warehouseImage from './images/warehouse.jpg';
import scheduleImage from './images/schedule.jpg';
import uomImage from './images/units-of-measure.jpg';
import productsImage from './images/products.jpg';
import standardsImage from './images/ccc-standards.jpg';
import locationsImage from './images/bay-locations.jpg';
import handlingImage from './images/handling-standards.jpg';
import costsImage from './images/costs.jpg';
import additionalChargesImage from './images/additional-charges.jpg';
import commoditiesImage from './images/commodities.jpg';
import warehouseInstructions from './images/warehouse-instructions.jpg';
import printers from './images/printers.jpg';

const pages = [
  {
    text: 'Warehouses',
    image: warehouseImage,
    path: '/warehouse/list',
  },
  {
    text: 'Schedules',
    image: scheduleImage,
    path: '/warehouse/schedules',
  },
  {
    text: 'Products',
    image: productsImage,
    path: '/warehouse/products',
  },
  {
    text: 'Units of Measure',
    image: uomImage,
    path: '/warehouse/units-of-measure',
  },
  {
    text: 'CCC Commodities',
    image: commoditiesImage,
    path: '/warehouse/ccc-commodities',
  },
  {
    text: 'CCC Standards',
    image: standardsImage,
    path: '/warehouse/ccc-standards',
  },
  {
    text: 'Handling Standards',
    image: handlingImage,
    path: '/warehouse/handling-standards',
  },
  {
    text: 'Bay Locations',
    image: locationsImage,
    path: '/warehouse/bay-locations',
  },
  {
    text: 'Additional Charges',
    image: additionalChargesImage,
    path: '/warehouse/additional-charges',
  },
  {
    text: 'Costs',
    image: costsImage,
    path: '/warehouse/costs',
  },
  {
    text: 'Instructions',
    image: warehouseInstructions,
    path: '/warehouse/instructions',
  },
  {
    text: 'Printers',
    image: printers,
    path: '/warehouse/printers',
  },
  {
    text: 'GL Codes',
    image: printers,
    path: '/warehouse/gl-codes',
  },
];

export default pages;
